import request from "@/utils/request";

// 推荐商铺查询
export function getRecommendShopList(params) {
  return request({
    url: `/shop/recommend/shop/list/0`,
    method: "GET",
    params,
  });
}
// 推荐商铺补位查询
export function getRecommendShopCoverList(params) {
  return request({
    url: `/shop/recommend/shop/pageList`,
    method: "GET",
    params,
  });
}
// 清空补位商品

export function emptyRecommendShopCoverList(params) {
  return request({
    url: `/shop/recommend/shop/clearComplementShop`,
    method: "DELETE",
    params,
  });
}

// 新增推荐商铺信息
export function addRecommendShop(data) {
  return request({
    url: `/shop/recommend/shop/save`,
    method: "POST",
    data,
  });
}

// 编辑推荐商铺信息
export function updateRecommendShop(data) {
  return request({
    url: `/shop/recommend/shop/update`,
    method: "POST",
    data,
  });
}

// 删除推荐商铺信息
export function deleteRecommendShop(id) {
  return request({
    url: `/shop/recommend/shop/${id}`,
    method: "delete",
  });
}

// 推荐商品查询 type 推荐商品类型（1：热销推荐，2：限时秒杀，3：盖楼推荐，4：商品推荐）
export function getRecommendGoodsList(params) {
  return request({
    url: `/product/recommend/goods/list`,
    method: "GET",
    params,
  });
}

// 编辑推荐商品信息
export function updateRecommendGoods(data) {
  return request({
    url: `/product/recommend/goods/update`,
    method: "POST",
    data,
  });
}

// 编辑推荐商品信息NEW
export function updateSurnameRecommendShop(data) {
  return request({
    url: `/product/recommend/goods/updateSurnameRecommendShop`,
    method: "POST",
    data,
  });
}

// 新增推荐商品信息
export function addRecommendGoods(data) {
  return request({
    url: `/product/recommend/goods/save`,
    method: "POST",
    data,
  });
}

// 编辑推荐商品信息
export function deleteRecommendGoods(id) {
  return request({
    url: `/product/recommend/goods/${id}`,
    method: "DELETE",
  });
}

// 查询推荐商品
export function getShopGoodsByShopIdList(params) {
  return request({
    url: `/product/recommend/goods/getShopGoodsByShopId`,
    method: "GET",
    params,
  });
}

// 盖楼推荐商品查询
export function getFloorRecommendShopList(params) {
  return request({
    url: `/product/recommend/goods/floorRecommendShopList`,
    method: "GET",
    params,
  });
}

// 根据楼层删除整层数据
export function deleteFloorRecommendGoods(floor) {
  return request({
    url: `/product/recommend/goods/byFloor/${floor}`,
    method: "DELETE",
  });
}
// 重新生成补位信息(店铺推荐)
export function regenerateRecommendShop(params) {
  return request({
    url: `/shop/recommend/shop/regenerateRecommendShop`,
    method: "GET",
    params,
  });
}
// 获取补位信息列表(热销推荐、限时秒杀、盖楼推荐、商品推荐)
export function getRecommendGoodsCoverList(params) {
  return request({
    url: `/product/recommend/goods/pageList`,
    method: "GET",
    params,
  });
}

// 清空生成补位信息(热销推荐、限时秒杀、盖楼推荐、商品推荐)
export function clearComplementGoods(type, params) {
  return request({
    url: `/product/recommend/goods/clearComplementGoods/${type}`,
    method: "DELETE",
    params,
  });
}

// 重新生成补位信息(热销推荐、限时秒杀、盖楼推荐、商品推荐)
export function regenerateRecommendGoods(type, params) {
  return request({
    url: `/product/recommend/goods/regenerateRecommendGoods/${type}`,
    method: "GET",
    params,
  });
}

// 推荐商铺排序
export function recommendShopSortUpdate(data) {
  return request({
    url: `/shop/recommend/shop/sort`,
    method: "POST",
    data,
  });
}

// 推荐商品排序
export function recommendGoodsSortUpdate(data) {
  return request({
    url: `/product/recommend/goods/sort`,
    method: "POST",
    data,
  });
}
// 新增诊所必备 -- 配置信息
export function goodsClinicEssentialBasicsConfigs(data) {
  return request({
    url: `/product/goods/goodsClinicEssentialBasicsConfigs`,
    method: "POST",
    data,
  });
}
// 编辑诊所必备 -- 配置信息列表
export function goodsClinicEssentialBasicsConfigsList(params) {
  return request({
    url: `/product/goods/goodsClinicEssentialBasicsConfigs`,
    method: "GET",
    params,
  });
}
// 编辑诊所必备 -- 修改配置信息
export function goodsClinicEssentialBasicsConfigsUpdate(data) {
  return request({
    url: `/product/goods/goodsClinicEssentialBasicsConfigs/${data.id}`,
    method: "PUT",
    data,
  });
}
// 删除诊所必备 -- 配置信息
export function goodsClinicEssentialBasicsConfigsDelete(id) {
  return request({
    url: `/product/goods/goodsClinicEssentialBasicsConfigs/${id}`,
    method: "DELETE",
  });
}
// 诊所必备 -已选商品列表
export function goodsClinicEssentialGoodsConfigsGetGoodsByConfigId(params) {
  return request({
    url: `/product/goods/goodsClinicEssentialGoodsConfigs/getGoodsByConfigId`,
    method: "GET",
    params,
  });
}
// 诊所必备 - 新增商品
export function goodsClinicEssentialGoodsConfigsAdd(data) {
  return request({
    url: `/product/goods/goodsClinicEssentialGoodsConfigs`,
    method: "POST",
    data,
  });
}
